module.exports = __webpack_public_path__ + "static/img/12.9a4de03.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/sp/12.png
// module id = sQa8
// module chunks = 0